import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatSelectionList, MatSelectionListChange, MatListOption } from '@angular/material/list';

import { Role } from '../../../shared/models/role.model';

@Component({
    selector: 'app-permissions-preview-filters',
    templateUrl: './per-pre-filters.component.html',
    styleUrls: ['./per-pre-filters.component.scss'],
    standalone: false
})
export class PermissionsPreviewFiltersComponent implements OnInit, AfterViewInit {
    // Inputs.
    @Input() siteRoles: Role[] = [];
    @Input() selectedRoles: Role[] = null; // Note:  these are initially selected roles.

    // Outputs.
    @Output() rolesUpdated: EventEmitter<any> = new EventEmitter();

    // Properties.
    //private selectedRoleNames: string[] = []; // Would be used if [(ngModel)] were being used on the <mat-selection-list/>.

    @ViewChild(MatSelectionList) rolesList: MatSelectionList;

    // Constructor.
    public constructor()
    {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        if ((this.selectedRoles != null) && (this.selectedRoles.length > 0)) {
            for (let iRole: number = 0; iRole < this.selectedRoles.length; iRole++) {
                let role: Role = this.selectedRoles[iRole];
            }
        }

        return;
    }

    public ngAfterViewInit(): void {
        this.onRolesSelectionChanged();
    }

    // Define methods called by my HTML code.
    public get SiteRoles(): Role[] {
        return (this.siteRoles);
    }

    public IsSelected(role: Role): boolean {
        // Note:  presently this method always returns true.
        let selectedRole: Role =
            (this.selectedRoles != null ? this.selectedRoles.find(r => r.id == role.id) : null);

        return (selectedRole != null);
    }

    // Handle control events.
    //public onRolesSelectionChanged(eventData: any): void {
    public onRolesSelectionChanged(): void {
        // Notify my parent of the selection change.
        let selectedRoleNames: string[] = this.rolesList.selectedOptions.selected.map(item => item.value);
        this.rolesUpdated.emit(selectedRoleNames);

        return;
    }
}
